<template>
    <div class="addTakeLook">
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item time">
                    <span>带看时间：</span>
                    <el-date-picker v-model="search.withLookDates" @change="currentPage=1,pageNumber=1,queryWithLookManage()" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li class="conditions_list_item" style="position:relative">
                    <span>带看人：</span>
                    <el-input @focus="departpopshow=!departpopshow" v-model="search.departmentName" placeholder="请选择所在部门" @clear="clearPerson" clearable></el-input>
                    <div class="departpop" v-show="departpopshow">
                        <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                            <span class="custom-tree-node" slot-scope="{ node,data}">
                                <div>
                                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                    <span>{{ data.name }}</span>
                                </div>
                            </span>
                        </el-tree>
                    </div>
                    <el-select v-model="search.employeeId" @clear="clearPerson" @change="currentPage=1,pageNumber=1,queryWithLookManage()" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in userList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>房源编号：</span>
                    <el-input v-model="search.houseCode" @input="currentPage=1,pageNumber=1,queryWithLookManage()" placeholder="请输入房源编号" clearable></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>客源编号：</span>
                    <el-input v-model="search.cusCode" @input="currentPage=1,pageNumber=1,queryWithLookManage()" placeholder="请输入客源编号" clearable></el-input>
                </li>
            </ul>
        </div>
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-click="rowColorclick" highlight-current-row>
                <el-table-column prop="withLookTime" label="带看日期"></el-table-column>
                <el-table-column prop="withLookPeople" label="带看人"></el-table-column>
                <el-table-column label="房源编号">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.id===isRowColor}" @click="goHouse(scope.row.houseId,scope.row.houseEmployeeId,scope.row.housingProperty)" style="color:#5e75e6;cursor:pointer;padding:0 20px">{{scope.row.houseCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="residentialAreaName" label="小区"></el-table-column>
                <el-table-column label="客源编号">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.id===isRowColor}" @click="goCustom(scope.row.customerId,scope.row.customerEmployeeId)" style="color:#5e75e6;cursor:pointer;padding:0 20px">{{scope.row.cusCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customerName" label="客源姓名"></el-table-column>
                <el-table-column prop="customerLevel" label="客户级别"></el-table-column>
                <el-table-column prop="accompanyName" label="陪看员工"></el-table-column>
                <el-table-column width="260" label="带看图片">
                    <template slot-scope="scope">
                        <!-- <span>{{scope.row.withLookPicture}}</span> -->
                        <div @click="checkWithLookPicturePermission(scope.row,'带看图片查看')">
                            <span style="padding: 0 4px" v-for="(item,index) in scope.row.withLookPicture" :key="index">
                                <img style="width: 28px;height:28px;margin-top:1px" v-if="index<5" :src="'http://'+item" alt />
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="withLookExplain" label="带看说明"></el-table-column>
                <el-table-column prop="withLookFeedBack" label="带看反馈"></el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>

        <div class="mask" v-if="imgListShow">
            <img class="close" @click="imgListShow=false" src="../../assets/images/close.png" alt />
            <template>
                <el-carousel indicator-position="outside" :autoplay='false'>
                    <el-carousel-item v-for="(item,index) in curImgList" :key="index">
                        <img :src="'http://'+item" alt />
                        <el-button class="download" v-if="ispc" @click="downLoadImg('http://'+item)" type="primary">下载</el-button>
                    </el-carousel-item>
                </el-carousel>
            </template>
        </div>
    </div>
</template>
<script type="text/javascript">
import AddKeyAlert from "@/components/common/addKeyAlert";
import { getRouterLevel } from '@/vue/util/tool'
import {
    queryKey,
    queryWithLookManage,
    departmentFind,
    employeeQuery,
    checkWithLookPicturePermission
} from "@/api/manageCenter";
import { queryName } from "@/api";
export default {
    // name: "带看管理",
    name: "/addTakeLook",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            isRowColor: "",
            total: 0,
            currentPage: 1,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            // state: "不限", //状态
            List: [], //跟进列表
            imgListShow: false,
            curImgList: [],
            KeyStateList: [], //钥匙状态列表
            followUpTypeList: [
                { name: "不限", value: 0 },
                { name: "房源", value: 1 },
                { name: "客源", value: 2 }
            ],
            departpopshow: false,
            departmentList: [],
            defaultProps: {
                children: "child"
            },
            userList: [],
            //搜索
            search: {
                withLookDates: "", //带看时间
                enterpriseCode: "",
                departmentId: "", //部门id
                departmentName: "", //部门名字
                cusCode: "", //员工编号
                houseCode: "", //房源编号
                permissionLevel: getRouterLevel('带看管理')//权限级别
            }
        };
    },

    inject: ['ispc'],

    components: {},
    mounted() {
        this.queryWithLookManage();
        this.getdepartmentFindAll();
        this.Getmessage();
        this.isRowColor = "";
        console.log(11, this.permisList);
    },
    activated() {
        this.queryWithLookManage();
        this.getdepartmentFindAll();
        this.Getmessage();
        this.isRowColor = "";
        console.log(11, this.permisList);
    },
    methods: {
        //带看图片权限校验
        checkWithLookPicturePermission(data, val) {
            console.log(data);
            if (getRouterLevel(val) == 0) {
                this.$message.error('暂无查看权限');
                return;
            }
            let params = {
                employeeId: data.employeeId,
                permissionLevel: getRouterLevel(val),
            };
            this.$post(checkWithLookPicturePermission, params).then(res => {
                if (res.success) {
                    this.curImgList = data.withLookPicture;
                    this.imgListShow = true;
                } else {
                    this.$message.error('暂无查看权限')
                }
            })
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },

        getdepartmentFindAll() {
            // 获取部门
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.search.departmentId = node.id;
            this.search.departmentName = node.name;
            this.departpopshow = false;
            this.Getmessage();
            this.queryWithLookManage();
        },

        Getmessage() {
            var params = {
                departmentId: this.search.departmentId,
                permissionLevel: getRouterLevel('带看管理'),
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then(res => {
                if (res.success === true) {
                    this.userList = res.data;
                }
            });
        },

        queryWithLookManage() {
            // 获取跟进列表
            this.isRowColor = "";
            let result = this.permisShow("带看管理");
            if (!result) {
                return false;
            }
            let params = Object.assign({}, this.search);
            params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
            params["page.pageSize"] = this.pageSize;
            this.$post(queryWithLookManage, params).then(res => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        goHouse(id, employeeId, houseSta) {
            if (houseSta == "SECONDHAND") {
                sessionStorage.setItem("sellHousebuildId", id);
                this.$store.commit("save_houseType", "SECONDHAND");
                this.$router.push("/buildDetail");
            } else if (houseSta == "RENTING") {
                sessionStorage.setItem("rentHousebuildId", id);
                this.$store.commit("save_houseType", "RENTING");
                this.$router.push("/rentingBuildDetail");
            } else if (houseSta == "SHOP_SALE") {
                sessionStorage.setItem("sellShopbuildId", id);
                this.$store.commit("save_houseType", "SHOP_SALE");
                this.$router.push("/sellShopDetails");
            } else if (houseSta == "SHOP_RENTAL") {
                sessionStorage.setItem("rentShopbuildId", id);
                this.$store.commit("save_houseType", "SHOP_RENTAL");
                this.$router.push("/rentShopDetails");
            }
            sessionStorage.setItem("buildId", id);
            sessionStorage.setItem("employeeId", employeeId);
        },

        goCustom(id, employeeId) {
            localStorage.setItem("customerId", id);
            sessionStorage.setItem("employeeId", employeeId);
            this.$router.push("/purchaseDetail");
        },

        clearPerson() {
            this.search.departmentName = "";
            this.search.departmentId = "";
            this.queryWithLookManage();
        },

        downLoadImg(item) {
            // 下载图片
            sessionStorage.setItem("downImg", item);
            this.$electron.ipcRenderer.send("open-directory-dialog");
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryWithLookManage();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryWithLookManage();
        },

        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        }
    }
};
</script>
<style type="text/css" lang="less">
.addTakeLook {
    height: 100%;
    .departpop {
        width: 170px;
        position: absolute;
        left: 60px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .key_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .conditions_list_item {
            padding: 0 10px;
            display: flex;
            align-items: center;
            margin: 5px 10px 5px 0;
            position: relative;
            // overflow: hidden;
            cursor: pointer;
            > span {
                font-size: 12px;
                color: #666;
                padding: 4px 0px 4px 0;
            }
            .el-date-editor {
                margin-left: 10px;
                width: 310px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #dbdbdb;
                .el-range__icon {
                    line-height: 25px;
                }
                .el-range-input {
                    // width: 310px;
                    line-height: 30px;
                    height: 28px;
                    border: none;
                    color: black;
                    padding-left: 30px;
                }
                .el-range-separator {
                    line-height: 26px;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 80px;
                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 80px;
                        height: 30px;
                        color: black;
                        padding: 0 5px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .shop {
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        width: 100px;
                        height: 30px;
                        color: black;
                        padding: 0;
                        border: 1px solid #dbdbdb;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }
    }
    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }

    .key_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        background: #fff;
        .el-input {
            width: 145px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
                padding: 0 10px;
                background: #cccccc;
                border: none;
            }

            .el-input__inner {
                height: 30px;
                border: 1px solid #dbdbdb;
            }

            .icon-icon_sousuo {
                color: white;
            }
        }

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }

        //弹出框样式
        .el-dialog {
            width: 500px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }
    }

    .key_list_wrap {
        height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }

        .footer_page {
            margin-top: 20px;
            position: relative !important;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }

    .mask .el-carousel__item {
        background: transparent;
        opacity: 1 !important;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9;
        .close {
            width: 20px;
            position: absolute;
            top: 0;
            right: 300px;
            padding: 50px;
            z-index: 100;
        }
        .delet {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 100px;
            z-index: 100;
            height: auto !important;
        }
        .edit {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 240px;
            z-index: 100;
            height: auto !important;
        }

        .el-carousel__container {
            margin: 0 auto;
            width: 80%;
            height: 90vh;
            z-index: 99;
            .el-carousel__arrow {
                font-size: 50px !important;
                padding: 20px;
                width: 100px;
                height: 100px;
            }
            // .el-carousel__arrow--left,.el-carousel__arrow--right{

            // }
        }

        .el-carousel__item {
            color: #475669;
            font-size: 18px;
            opacity: 0.75;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            // min-height: 400px;
            .download {
                border: none;
                background: #22ca85;
                color: #ffffff;
                position: absolute;
                padding-left: 36px;
                padding-right: 36px;
                bottom: 0;
                right: 500px;
                z-index: 100;
                height: auto !important;
            }
            .uploadtime {
                width: 100%;
                line-height: 24px;
                color: #fff;
                position: absolute;
                left: 100px;
                bottom: 0;
            }
            > img {
                height: 90%;
            }
        }
        .door_modle_introduced {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            padding: 0 100px;
            .introduced_toward {
                display: flex;
                flex-direction: column;
                > span {
                    font-size: 14px;
                    color: #ffffff;
                }

                .el-textarea {
                    margin-top: 10px;
                    .el-textarea__inner {
                        width: 260px;
                        height: 60px;
                        background: #f5f5f5;
                        border: 1px solid #ccc;
                    }
                }
            }
            .el-select {
                margin-top: 10px;
                .el-input {
                    .el-input__inner {
                        padding-left: 10px !important;
                        font-size: 16px !important;
                        width: 100px !important;
                        height: 30px !important;
                        line-height: 30px !important;
                        background: #f5f5f5;
                        border: 1px solid #ccc !important;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #99a9bf;
        // }

        // .el-carousel__item:nth-child(2n+1) {
        //   background-color: #d3dce6;
        // }
    }
}
</style>
